module.exports = __webpack_public_path__ + "static/media/preset_aged_photo.2759d218.jpg";